<template>
  <div class="laybg">
    <wheader :currtabs="currPage"></wheader>
    <router-view></router-view>
    <wfooter></wfooter>
  </div>
</template>
<script>

import wheader from "./header.vue";
import wfooter from "./footer.vue";
import "./main.css";
import "../assets/iconfont/base/iconfont.css";
import "../assets/css/bootstrap.css";
export default {
  components: { wheader, wfooter },
  data() {
    return {
      currPage: 0,
    };
  },
  mounted(){
    if(window.localStorage.getItem('currLang')==null) 
    {
      abp.localization.currentCulture={"name":"zh-Hans","displayName":"中文(简体)"}
      abp.localization.currentLanguage={"name":"zh-Hans","displayName":"简体中文","icon":"famfamfam-flags cn","isDisabled":false,"isDefault":true}
      window.localStorage.setItem('currCul',JSON.stringify({"name":"zh-Hans","displayName":"中文(简体)"}))
      window.localStorage.setItem('currLang',JSON.stringify({"name":"zh-Hans","displayName":"简体中文","icon":"famfamfam-flags cn","isDisabled":false,"isDefault":true}))
    }else{
      abp.localization.currentLanguage=JSON.parse(window.localStorage.getItem('currLang'))
      abp.localization.currentCulture=JSON.stringify(window.localStorage.getItem('currCul'))
    }
  },
  methods: {

  },
};
</script>
<style scoped>
.laybg {
  background-size: 100% 100%;
  background-attachment: fixed;
  background-image: url("../assets/castbead/bg1.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
</style>